import { useAppStateSelector } from "./useAppStateSelector"

/**
 * Preact hook that import current state to the component.
 *
 * **Should always be at the top of the component!**
 *
 * See also: [useAppStateSelector](./useAppStateSelector.ts)
 *
 * @example
 * ```jsx
 * import { useAppState } from '@nosto/preact'
 *
 * export default () => {
 *     const { query } = useAppState()
 *
 *     return <div>
 *         Searching for {query.query}
 *     </div>
 * }
 * ```
 *
 * @group Hooks
 * @deprecated Use `useAppStateSelector` instead.
 */
export function useAppState() {
    return useAppStateSelector(state => state)
}
